// src/components/home/FeaturedProducts.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import ScrollReveal from "../common/ScrollReveal";

import "swiper/css";
import "swiper/css/navigation";

const FeaturedProducts = ({ products = [], title = "Featured Products" }) => {
  if (!products || products.length === 0) {
    return null;
  }

  return (
    <section className="py-2 sm:py-4">
      <div className="w-full">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-brand-foreground mb-6 sm:mb-8">
          {title}
        </h2>

        <div className="homepage-products-swiper relative px-2 sm:px-4 md:px-8">
          <Swiper
            modules={[Navigation]}
            loop={true}
            spaceBetween={12}
            slidesPerView={1}
            slidesPerGroup={1}
            centeredSlides={false}
            navigation={true}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 16,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
            }}
          >
            {products.map((product, index) => {
              const imageUrl = product.image?.url
                ? `${product.image.url}`
                : null;
              const altText =
                product.image?.alternativeText ||
                product.btnText ||
                `Product ${index + 1}`;
              const delayClass = `homepage-fade-up-item--d${(index % 4) + 1}`;

              return (
                <SwiperSlide key={product.id || index}>
                  <ScrollReveal className={`homepage-fade-up-item ${delayClass}`}>
                    <div className="panel-elevated rounded-lg p-3 sm:p-4 flex flex-col h-full">
                      <div className="aspect-square mb-3 sm:mb-4 flex items-center justify-center overflow-hidden bg-slate-100 rounded">
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt={altText}
                            className="max-w-full max-h-full object-contain"
                          />
                        ) : (
                          <div className="w-full h-full bg-slate-200/90 flex items-center justify-center">
                            <span className="text-slate-500 text-sm">
                              No Image
                            </span>
                          </div>
                        )}
                      </div>

                      {product.btnText && (
                        <Link
                          to={product.btnUrl || "#"}
                          className="mt-auto inline-flex items-center justify-center w-full gap-2 py-1.5 sm:py-2 px-3 sm:px-4 rounded-full border border-lake-500/20 text-white text-sm sm:text-base font-semibold bg-lake-400 hover:bg-lake-500 hover:border-lake-500/30 transition-colors duration-200"
                        >
                          <span>{product.btnText}</span>
                          <span className="text-xs sm:text-sm" aria-hidden="true">
                            &#8594;
                          </span>
                        </Link>
                      )}
                    </div>
                  </ScrollReveal>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
